<!-- Placeholder loading for text -->
<!-- <div class="skeleton-text" style="width: 300px; height: 20px"></div> -->
<div class="skeleton-text" style="height: 20px"></div>
<!-- <div
  class="skeleton-text"
  style="width: 200px; height: 20px; margin-top: 10px"
></div> -->
